var map = {
	"./account.svg": "./public/images/icons/account.svg",
	"./angle-down-solid.svg": "./public/images/icons/angle-down-solid.svg",
	"./angle-left-regular.svg": "./public/images/icons/angle-left-regular.svg",
	"./angle-right-regular.svg": "./public/images/icons/angle-right-regular.svg",
	"./angle-up-solid.svg": "./public/images/icons/angle-up-solid.svg",
	"./bag-2.svg": "./public/images/icons/bag-2.svg",
	"./calendar-alt-solid.svg": "./public/images/icons/calendar-alt-solid.svg",
	"./caret-down.svg": "./public/images/icons/caret-down.svg",
	"./caret-left.svg": "./public/images/icons/caret-left.svg",
	"./caret-right.svg": "./public/images/icons/caret-right.svg",
	"./caret-up.svg": "./public/images/icons/caret-up.svg",
	"./check.svg": "./public/images/icons/check.svg",
	"./chevron-down.svg": "./public/images/icons/chevron-down.svg",
	"./chevron-left.svg": "./public/images/icons/chevron-left.svg",
	"./chevron-right.svg": "./public/images/icons/chevron-right.svg",
	"./chevron-up.svg": "./public/images/icons/chevron-up.svg",
	"./circle-check.svg": "./public/images/icons/circle-check.svg",
	"./clock-solid.svg": "./public/images/icons/clock-solid.svg",
	"./credit_cards/amex.svg": "./public/images/icons/credit_cards/amex.svg",
	"./credit_cards/discover.svg": "./public/images/icons/credit_cards/discover.svg",
	"./credit_cards/mastercard.svg": "./public/images/icons/credit_cards/mastercard.svg",
	"./credit_cards/visa.svg": "./public/images/icons/credit_cards/visa.svg",
	"./exclamation-circle-light.svg": "./public/images/icons/exclamation-circle-light.svg",
	"./gift-card-balance.svg": "./public/images/icons/gift-card-balance.svg",
	"./hamburger-menu.svg": "./public/images/icons/hamburger-menu.svg",
	"./heart-break.svg": "./public/images/icons/heart-break.svg",
	"./info.svg": "./public/images/icons/info.svg",
	"./location-arrow.svg": "./public/images/icons/location-arrow.svg",
	"./lock.svg": "./public/images/icons/lock.svg",
	"./map-marker-alt-solid.svg": "./public/images/icons/map-marker-alt-solid.svg",
	"./minus-circle-solid.svg": "./public/images/icons/minus-circle-solid.svg",
	"./plus-circle-solid.svg": "./public/images/icons/plus-circle-solid.svg",
	"./price-tag.svg": "./public/images/icons/price-tag.svg",
	"./receipt-ghost.svg": "./public/images/icons/receipt-ghost.svg",
	"./shopping-bag-solid.svg": "./public/images/icons/shopping-bag-solid.svg",
	"./spinner-solid.svg": "./public/images/icons/spinner-solid.svg",
	"./star.svg": "./public/images/icons/star.svg",
	"./success-check.svg": "./public/images/icons/success-check.svg",
	"./upserve-lockup.svg": "./public/images/icons/upserve-lockup.svg",
	"./upserve.svg": "./public/images/icons/upserve.svg",
	"./user.svg": "./public/images/icons/user.svg",
	"./x.svg": "./public/images/icons/x.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/images/icons sync recursive ^\\.\\/.*\\.svg$";